import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {NgForm} from "@angular/forms";

import {CustomerService} from "@app/services/net-remit/customer.service";

import {CustomerEntityView} from "@app/shared/models/CustomerEntityView";
import {
  SingleCleanupConfigurationInfoView
} from "@app/shared/models/administration/cleanup/SingleCleanupConfigurationInfoView";
import {ComboKeysView} from "@app/shared/models/ComboKeysView";

import {default as constantsFile} from '@app/shared/constants.json';

import {finalize} from "rxjs/internal/operators/finalize";
import {takeWhile} from "rxjs/operators";
import {AdministrationCleanupService} from '@app/services/net-remit/administration.cleanup.service';

@Component({
  selector: 'app-administration-manual-cleanup-form',
  templateUrl: './manual-cleanup-form.component.html',
  styleUrls: ['./manual-cleanup-form.component.scss'],
  standalone: false
})
export class ManualCleanupFormComponent implements OnInit {
  public alive: boolean = true;
  public constants: any = constantsFile.constants;
  public countriesList: Array<ComboKeysView>;
  public customersList: Array<CustomerEntityView>;
  public periods: Array<ComboKeysView> = new Array<ComboKeysView>();

  @Input() manualCleanup: SingleCleanupConfigurationInfoView;
  @Input() isLoading: boolean;
  @Input() isLoadingPeriods: boolean;
  @Output() showToastMethod = new EventEmitter<{
    isClosabled: boolean,
    severity: string,
    summary: string,
    isSticky: boolean,
    detail: string
  }>();
  @Output() isLoadingMethod = new EventEmitter<boolean>();
  @Output() isLoadingPeriodsMethod = new EventEmitter<boolean>();

  @ViewChild('manualCleanupForm') manualCleanupForm: NgForm;

  constructor(
    private customerService: CustomerService,
    private administrationCleanupService: AdministrationCleanupService
  ) {
  }

  ngOnInit() {
    this.customerService.findAllCustomers({
      typeCustomer: this.constants.customerTypes.airline,
      onlyGNR5: true,
      onlyActive: false,
      addAccelya: false
    })
      .pipe(finalize(() => {
        this.isLoadingMethod.emit(false)
      }), takeWhile(() => this.alive))
      .subscribe({
        next: (customers) => {
          this.customersList = customers;
        },
        error: () => {
          this.showToastMethod.emit({
            isClosabled: false,
            severity: "error",
            summary: "Modal.Error",
            isSticky: true,
            detail: "Generic Errors.Error Generic Onload"
          });
        }
      });
  }

  public customerSelected(): void {
    this.manualCleanup.countries = [];
    this.initCountriesList();
    this.countrySelected({});
  }

  public countrySelected(newOption: any): void {
    this.initPeriods();
    this.isLoadingPeriodsMethod.emit(true);
    this.manualCleanup.countries = newOption.value ?? this.countriesList.map(c => c.keyValue);
    this.customerService.getPeriodsByCustomerAndCountry(new SingleCleanupConfigurationInfoView(this.manualCleanup.customerId, undefined, undefined, (this.isAllValues() ? [] : this.manualCleanup.countries)))
      .pipe(finalize(() => {
        this.isLoadingPeriodsMethod.emit(false)
      }), takeWhile(() => this.alive))
      .subscribe({
        next: (periods: string[]) => {
          if (periods === null || periods.length === 0) {
            this.showToastMethod.emit({
              isClosabled: true,
              severity: "warn",
              summary: "Generic Warnings.Warning",
              isSticky: false,
              detail: "Generic Warnings.No Data To Show"
            });
          } else {
            this.periods = periods.map(period => new ComboKeysView(period, period));
          }
        },
        error: () => {
          this.showToastMethod.emit({
            isClosabled: true,
            severity: "error",
            summary: "Modal.Error",
            isSticky: false,
            detail: "Generic Errors.Error Generic Onload"
          });
        }
      });
  }

  public clean() {
    this.manualCleanupForm.controls['periodTo'].reset();
    this.manualCleanupForm.controls['periodFrom'].reset();
  }

  private initCountriesList(): void {
    this.countriesList = [];

    this.administrationCleanupService.getAllCountries(this.manualCleanup.customerId).subscribe((countryList) => {
        countryList.forEach(country => {
          this.countriesList.push(
            new ComboKeysView(country, country)
          );
        });
      }
    )

    this.countriesList = Array.from(
      new Map(this.countriesList.map(item => [item.keyValue, item])).values()
    ).sort((a, b) => a.keyValue.localeCompare(b.keyValue));
  }

  private initPeriods(): void {
    this.manualCleanup.periodFrom = undefined;
    this.manualCleanup.periodTo = undefined;
    this.isLoadingPeriodsMethod.emit(true);
    this.periods = [];
  }

  private isAllValues(): boolean {
    return this.manualCleanup.countries.length == this.countriesList.length;
  }
}
